import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { guardConsole } from './environments/console-guard';

import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import localeFrExtra from '@angular/common/locales/extra/fr';

import * as L from 'leaflet';

if (environment.production) {
  enableProdMode();
}
guardConsole();
registerLocaleData(localeFr, 'fr-FR', localeFrExtra);

// ✅ FIX audit DGCPT #2.3 : Leaflet chargeait auparavant via un <script> CDN
// (unpkg.com), maintenant importe via npm (voir angular.json/index.html).
// L.Icon.Default._getIconUrl() tente d'auto-detecter le chemin de ses
// images en lisant document.styleSheets, ce qui echoue avec un bundler
// (nom de fichier CSS hashe) - config explicite requise, sans quoi les
// marqueurs par defaut de L.marker(...) (map-mairie, map-tresor,
// map-parking, dashboard-ministere) s'afficheraient casses.
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'assets/leaflet/marker-icon-2x.png',
  iconUrl: 'assets/leaflet/marker-icon.png',
  shadowUrl: 'assets/leaflet/marker-shadow.png',
});

platformBrowserDynamic().bootstrapModule(AppModule)
.catch(err => console.error(err));

